import Gen4Awards24 from "./gen4Awards24";

export default Gen4Awards24;
